module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "36px",
      "height": "36px",
      "viewBox": "0 0 36 36",
      "version": "1.1"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "ignorehover",
    attrs: {
      "id": "Plus-Accent",
      "fill": "#1E7BBB"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Rectangle-4",
      "points": "17.4857143 0 18.5142857 0 18.5142857 17.4857143 36 17.4857143 36 18.5142857 18.5142857 18.5142857 18.5142857 36 17.4857143 36 17.4857143 18.5142857 0 18.5142857 0 17.4857143 17.4857143 17.4857143"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2251abef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/crosshair.vue
// module id = 602
// module chunks = 1